import FamilyTreeFeature from "../components/family-tree/FamilyTreeFeature";

export default function FamilyTreePage() {
  return <FamilyTreeFeature />;
}
